module.exports = __webpack_public_path__ + "static/media/HINDPETRO_F1.5e2e5d80.txt";